<template>
  <basic-container
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <el-form label-width="100px" ref="form">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="项目名称">
            <el-select
              v-model="form.projectId"
              placeholder="项目名称"
              style="width: 100%"
              @change="(value) => projectChange(value, 1)"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="区域名称">
            <el-select
             clearable
            @change="(value) => areaChange(value, 1)" 
            v-model="form.areaId" placeholder="区域名称" style="width: 100%">
              <el-option
                v-for="item in areaList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="场馆类型">
            <el-select 
            @change="(value) => typeChange(value, 1)"
            v-model="form.type" placeholder="场馆类型" style="width: 100%">
              <el-option
                v-for="item in typeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="可容纳人数">
            <el-input v-model="form.capactity" placeholder="可容纳人数" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="开始时间">
            <el-time-select
              style="width: 100%"
              placeholder="开始时间"
              v-model="form.startTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30',
              }"
            >
            </el-time-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="结束时间">
            <el-time-select
              style="width: 100%"
              placeholder="结束时间"
              v-model="form.endTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30',
                minTime: form.startTime,
              }"
            >
            </el-time-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          
        <div style="text-align: right; box-sizing: border-box; padding-bottom: 32px">
            <el-button 
                @click="searchHandler"
                icon="el-icon-search" 
                size="small" 
                type="primary"
            >
            搜索 
            </el-button>
            <el-button 
                @click="resetHandler"
                icon="el-icon-delete" 
                size="small" 
                type="default"
            > 
            清空 
            </el-button>
        </div>
        </el-col>
      </el-row>
      <el-row>
      </el-row>
      <el-row>
        <div>

        </div>
        <el-form-item label="场馆名称">
          <el-select
            v-model="form.venueId"
            placeholder="请选择场馆"
            style="width: 50%"
            @change="(value) => venueChange(value, 1)"
          >
            <el-option v-for="item in venueList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <el-tooltip class="item" effect="dark" placement="top-end">
              
  <div slot="content" v-html="tipInfo||''"></div>
      <i class="el-icon-warning"></i>
    </el-tooltip>
        </el-form-item>
      </el-row>
    </el-form>
    <FullCalendar
    v-if="showTimeGridFlag"
      ref="fullCalendar"
      :options="calendarOptions"
      timezone="local"
      locale="zh-cn"
      firstDay="1"
      style="padding-bottom: 20px"
    />
  <el-dialog title="场馆租赁详情" class="dialog-detail-class"
        v-if="dialogFormVisibleDetail" :visible.sync="dialogFormVisibleDetail" append-to-body>
    <div>
      <detail-form-dialog-detail
        ref="detailFormDialogDetail"
        @detailClose="handleCloseDetailDialog"
        v-if="dialogFormVisibleDetail"
        :dialogFormVisibleDetail.sync="dialogFormVisibleDetail"
        :detailForm.sync="detailForm"
        :projectList.sync="projectList"
        :areaList.sync="areaList"
        :typeList.sync="typeList"
        :venueList.sync="venueList"
      ></detail-form-dialog-detail>
    </div>
  </el-dialog>
       
  <el-dialog title="场馆申请" custom-class="add-dialog" v-if="dialogFormVisibleAdd" :visible.sync="dialogFormVisibleAdd" append-to-body>
    
    <detail-form-dialog-add
        ref="detailFormDialogAdd"
        v-if="dialogFormVisibleAdd"
        @addClose="handleCloseAddDialog"
        :dialogFormVisibleAdd.sync="dialogFormVisibleAdd"
        :addForm.sync="addForm"
        :projectList.sync="projectList"
        :typeList.sync="typeList"
    ></detail-form-dialog-add>
    
  </el-dialog>
  </basic-container>
</template>

<script>
import $ from 'jquery';
import dayjs from 'dayjs';
import { getProjectList } from '@/api/crmedical/project/project';
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getAreaList,
  getVenueNameList,
  getVenueTypeList,
  getVenueChargeTypeList,
  getVenueList,
  getApplyList,
  getApplyDetail,
  getServiceConfigList
} from '@/api/v4ward/stadium-management/apply';

import FullCalendar from '@fullcalendar/vue';
import DetailFormDialogDetail from './stadium-apply-dialog-detail';
import DetailFormDialogAdd from './stadium-apply-dialog-add';
// import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction';
import timegridPlugin from '@fullcalendar/timegrid';

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    DetailFormDialogDetail,
    DetailFormDialogAdd
  },
  data() {
    return {
      showTimeGridFlag:true,
      tipInfo:'',
      areaList:[],
      formLabelWidth: '120px',
      detailForm:{},
      addForm:{},
      dialogFormVisibleDetail:false,
      dialogFormVisibleAdd:false,
      fullscreenLoading:false,
      venueList: [],
      typeList: [],
      projectList: [],
      form: {
          areaId:'',
      },
      calendarOptions: {
        selectable: true,
        firstDay: 1,
        select: (info) => {
          let self = this;
          console.log(info,'select');
          console.log("select===this===>",this);
          let startDate = dayjs(info.start).format('YYYY-MM-DD');
          let endDate = dayjs(info.end).format('YYYY-MM-DD');
          if(startDate!==endDate){
            this.$message.error("请不要跨天预约哦~");
            return;
          }
          if(!this.form.projectId){
            this.$message.error('请选择项目！');
            return;
          }
          if(!this.form.venueId){
            this.$message.error('请选择场馆！');
            return;
          }
              this.addForm = {
                projectId:self.form.projectId,
                venueId:self.form.venueId,
                areaId:self.form.areaId,
                type:self.form.type,
              };
              console.log(this.venueList);
          this.dialogFormVisibleAdd = true;
          setTimeout(()=>{
              this.$refs.detailFormDialogAdd.resetFormData(this.venueList,info,'select');
          });
        },
        eventClick: (info) => {
          console.log("eventClick===this===>",this);
            this.fullscreenLoading = true;
          console.log(info.event);
          getApplyDetail({id:info.event.id}).then((res)=>{
                this.fullscreenLoading = false;
                console.log("getApplyDetail====>",res.data);
          console.log("eventClick===this===>",this);
                this.dialogFormVisibleDetail = true;
                this.detailForm = res.data;
                getAreaList({ projectId: res.data.projectId }).then(({ data }) => {
                    console.log('getAreaList=========>',data);
                    this.areaList = data;
                });
          });
        },
        plugins: [timegridPlugin, interactionPlugin], //扩展
        initialView: 'timeGridWeek', //视图类型
        allDaySlot: false, //确定“全天”位置是否显示在日历的顶部 默认为true
        slotDuration: '00:30:00', //显示时隙的频率
        //头部标题格式化
        // titleFormat: {
        //   month: '2-digit',
        //   day: 'numeric',
        // },
				// titleFormat: '会议室申请',
        //表头格式化
        dayHeaderFormat: {
          // weekday: 'long',
          month: '2-digit',
          day: '2-digit',
          omitCommas: true,
        },
        //左侧时间轴格式化
        slotLabelFormat: {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false, //设置时间为24小时
        },
        dayNames: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
        dayNamesShort: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
        //事件时间格式化
        eventTimeFormat: {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          meridiem: false,
          hour12: false, //设置时间为24小时
        },
        //头部按钮布局
        headerToolbar: {
          left: '',
					center: '',
          right: 'today,prev,next',
        },
        //头部按钮内容重写
        buttonText: {
          prev: '上周',
          next: '下周',
          prevYear: '去年',
          nextYear: '明年',
          today: '本周',
          month: '月',
          week: '周',
          day: '日',
        },
        //事件集合
        events: [
        ],
        //表头内容注入
        dayHeaderContent: function (arg) {
          //周索引
          let weekDay = arg.dow;
          let weekName;
          switch (weekDay) {
            case 0:
              weekName = '周日';
              break;
            case 1:
              weekName = '周一';
              break;
            case 2:
              weekName = '周二';
              break;
            case 3:
              weekName = '周三';
              break;
            case 4:
              weekName = '周四';
              break;
            case 5:
              weekName = '周五';
              break;
            case 6:
              weekName = '周六';
              break;
          }
          weekName += ' ' + arg.text.replace('/', '-');
          return weekName;
        },
      },
    };
  },
  mounted() {
      let calendarApi = this.$refs.fullCalendar.getApi()
        console.log(this.$refs.fullCalendar)
        console.log(this.$refs.fullCalendar.getApi())
        $('.fc-prev-button').click(()=>{
          console.log('prev');
          this.getVenueApplyList(calendarApi)
        });
        $('.fc-next-button').click(()=>{
          console.log('next');
          this.getVenueApplyList(calendarApi)
        });
        $('.fc-today-button').click(()=>{
          console.log('next');
          this.getVenueApplyList(calendarApi)
        });
      
    getProjectList().then((res) => {
      this.projectList = res.data;
      this.form.projectId = this.projectList[0].id;
      getAreaList({ projectId: this.form.projectId }).then(({ data }) => {
        console.log('getAreaList=====>', data);
        this.areaList = data;
        this.form.areaId = data[0].id;
        getVenueList(this.form).then((res) => {
            this.venueList = res.data;
            this.form = Object.assign({},this.form,{
              venueId:res.data[0].id
            })
        this.handleVenueInfo();
            let calendarApi = this.$refs.fullCalendar.getApi()
            this.getVenueApplyList(calendarApi);
        });
      });
    });
  },
  activated(){
  },
  created() {
    getVenueTypeList().then((res) => {
      this.typeList = res.data;
      this.form.type = this.typeList[0].dictKey;
      
    });
  },
  methods: {
    resetCalendarStyle(){
      let self = this;
      this.$refs.fullCalendar.$el
      .querySelector('.fc-header-toolbar')
      .querySelectorAll('.fc-toolbar-chunk')[0].innerHTML = '<div style="display:flex;"><div style="flex:1"><div style="margin:0 10px;display:inline-block;width:10px;height:10px;background-color:#fff68f;"></div>待审核</div><div style="flex:1"><div style="margin:0 10px;display:inline-block;width:10px;height:10px;background-color:#b0e2ff;"></div>已通过</div><div style="flex:1"><div style="margin:0 10px;display:inline-block;width:10px;height:10px;background-color:#ff6a6a;"></div>未通过</div><div style="flex:1"><div style="margin:0 10px;display:inline-block;width:10px;height:10px;background-color:#7fffd4;"></div>已付款</div></div>'
      this.$refs.fullCalendar.$el
      .querySelector('.fc-header-toolbar')
      .querySelectorAll('.fc-toolbar-chunk')[1].innerText = '会议室申请'
      setTimeout(()=>{
        $(self.$refs.fullCalendar.$el)
        .find('td[data-time="00:00:00"][class="fc-timegrid-slot fc-timegrid-slot-label fc-scrollgrid-shrink"]')
        .find('div[class="fc-timegrid-slot-label-cushion fc-scrollgrid-shrink-cushion"]')[0]
        .innerText = '00:00';
      })
    },
    getColorByStatus(applyStatus){
      let color = '';
      switch (parseInt(applyStatus)) {
        case 1:
          // 待审批
        color = "#fff68f";
          break;
        case 2:
          // 已核准
        color = "#b0e2ff";
          break;
        case 3:
          // 已付款
        color = "#7fffd4";
          break;
        case 4:
          // 已撤销
        color = "";
          break;
        case 5:
          // 已作废/未通过
        color = "#ff6a6a";
          break;
      
        default:
          break;
      }
      return color;
    },
      triggerGetVenueList(type){
        console.log("<=======triggerGetVenueList=======>");
            this.venueNameList = [];
            this.venueList = [];
            this.form.venueId = '';
            this.handleVenueInfo();
        if(this.form.areaId&&this.form.projectId&&this.form.type){
            
          getVenueList(this.form).then((res) => {
            this.venueList = res.data;
            this.form = Object.assign({},this.form,{
              venueId:res.data[0].id
            })
            this.handleVenueInfo();
              let calendarApi = this.$refs.fullCalendar.getApi()
              this.getVenueApplyList(calendarApi);
          });
        }
      },
    getVenueApplyList(calendarApi){
        let self = this;
        console.log(calendarApi.getDate());
        let startDate = dayjs(calendarApi.getDate()).startOf('week').add(1,'day').format('YYYY-MM-DD');
        let endDate = dayjs(calendarApi.getDate()).endOf('week').add(1,'day').format('YYYY-MM-DD');
        getApplyList({venueId:this.form.venueId,startTime:startDate,endTime:endDate}).then((res)=>{
          console.log(res);
          let events = [];
          res.data.forEach((ele, index) => {
            events.push({
              textColor:'#000000',
              borderColor:'#000000',
							color: self.getColorByStatus(ele.applyStatus),
              id: ele.id,
              title: ele.description||'暂无',
              start: ele.startTime,
              end: ele.endTime,
            });
          });
          this.calendarOptions.events = events;
          setTimeout(()=>{
            console.log(document.querySelectorAll('.fc-event-time'));
            document.querySelectorAll('.fc-event-time').forEach((ele)=>{
              console.log(ele.innerText.indexOf('24'));
              if(ele.innerText.indexOf('24')==0){
                console.log(ele.innerText.replace(/24/g, "00"))
                ele.innerText = ele.innerText.replace(/24/g, "00")
              }
            });
          })
          this.resetCalendarStyle();
        });
    },
      handleCloseDetailDialog(value){
        let self = this;
        if(value==='remove'){
          this.dialogFormVisibleDetail = false;
          this.venueChange(self.form.venueId, 1);
        }
        if(value==='cancel'){
          this.dialogFormVisibleDetail = false;
        }
      },
      handleCloseAddDialog(value){
        let self = this;
        if(value==='submit'){
          this.dialogFormVisibleAdd = false;
          this.venueChange(self.form.venueId, 1);
        }
        if(value==='cancel'){
          this.dialogFormVisibleAdd = false;
        }
      },
      testFunc(){
          console.log(this.$refs);
      },
    areaChange(val){
        this.form = Object.assign({},this.form,{
            areaId:val
        });
        console.log(val);
        this.triggerGetVenueList();
    },
    typeChange(val){
        this.form = Object.assign({},this.form,{
            type:val
        });
        console.log(val);
        this.triggerGetVenueList();
    },
    handleDateClick(val) {
      console.log(val);
    },
    handleSelect(val) {
      console.log(val);
    },
    resetHandler(){
      let self = this;
      let projectId = this.form.projectId
        this.form = {
            projectId:projectId,
            type:self.typeList[0].dictKey
        };
        getVenueList(this.form).then((res) => {
            this.venueList = res.data;
              this.form = Object.assign({},this.form,{
                venueId:res.data[0].id
              })
      this.handleVenueInfo();
              let calendarApi = this.$refs.fullCalendar.getApi()
              this.getVenueApplyList(calendarApi);
        });
    },
    searchHandler(){
        getVenueList(this.form).then((res) => {
            this.venueList = res.data;
            // if(!this.form.venueId){
              this.form = Object.assign({},this.form,{
                venueId:''
              })
              if(res.data&&res.data.length>0){
                this.form = Object.assign({},this.form,{
                  venueId:res.data[0].id
                })
              }
            // }
          this.handleVenueInfo();
          let calendarApi = this.$refs.fullCalendar.getApi()
          this.getVenueApplyList(calendarApi);
        });
    },
    projectChange(value, type) {
      if (type) {
        this.form.projectId = value;
        this.form.areaId = '';
        this.form.venueId = '';
      } else {
        this.query.projectId = value;
        this.query.areaId = '';
        this.form.venueId = '';
      }
            this.handleVenueInfo();
      getAreaList({ projectId: value }).then(({ data }) => {
        console.log('getAreaList=====>', data);
        this.areaList = data;
      });

      getVenueList(this.form).then((res) => {
          this.venueList = res.data;
      });
      this.$forceUpdate();
    },
    handleVenueInfo(){
      let self = this;
      if(!self.form.venueId){
        self.tipInfo = "暂无信息";
        return;
      }
      self.venueList.forEach((ele)=>{
        if(self.form.venueId === ele.id){
          let tipArrWork = [];
          let tipArrNotWork = [];
          ele.chargeInfos.forEach((ele_)=>{
            if(ele_.workingDayFlag==1){
              tipArrWork.push(ele_.startTime+'-'+ele_.endTime+' '+ele_.price+'/小时');
            }
            if(ele_.workingDayFlag==2){
              tipArrNotWork.push(ele_.startTime+'-'+ele_.endTime+' '+ele_.price+'/小时');
            }
          });
          self.tipInfo = '工作日:</br>'+tipArrWork.join(',</br>')+'</br>'+'非工作日:</br>'+tipArrNotWork.join(',</br>')
        }
      });
    },
    venueChange(value, type) {
      this.form = Object.assign({},this.form,{
        venueId:value
      })
      this.handleVenueInfo();
      let calendarApi = this.$refs.fullCalendar.getApi()
        this.getVenueApplyList(calendarApi)
    },
  },
};
</script>

<style lang="scss" scoped>

.fc .fc-timegrid-body {
  min-height: 1055px;
}

.fc .fc-timegrid-slots {
  border-bottom: 1px solid #ddd;
}

::v-deep .fc-direction-ltr .fc-button-group > .fc-button:not(:last-child) {
  background-color: #2d8cf0;
  border: none;
  border-radius: 4px;
  margin-right: 10px;
}

::v-deep .fc-direction-ltr .fc-button-group > .fc-button:not(:first-child) {
  background-color: #2d8cf0;
  border: none;
  border-radius: 4px;
}

.fc .fc-button-group > .fc-button:focus,
.fc .fc-button-group > .fc-button:active,
.fc .fc-button-group > .fc-button.fc-button-active {
  z-index: 0;
}
    ::v-deep .el-select{
        width:100%;
    }
    ::v-deep .el-tabs__content{
        height: 60vh;
        overflow-y: scroll;
    }
    ::v-deep .dialog-detail-class>.el-form{
        height: 60vh;
        overflow-y: scroll;
    }
</style>